import { YES_FLAG } from '../../shared/constants';

export const getObligationUniqueId = ({ countryTaxType, companyCode, countryCode, meta = {} }) => !meta.isAdded
  ? `${countryTaxType}_${companyCode}_${countryCode}`
  : null;

export const areEqualObligations = (o1, o2) =>
  getObligationUniqueId(o1) === getObligationUniqueId(o2);

export const createObligationRow = () => ({
  enabledFlag: YES_FLAG,
  companyCode: '',
  legalEntity: '',
  countryCode: '',
  countryTaxType: '',
  countryTaxTypeDescription: '',
  chartName: '',
  connectionName: null,
  usTaxType: '',
  localTaxType: null,
  statCurrency: null,
  functionalCurrency: '',
  taxCurrency: '',
  secondaryTax: null,
  recordFTC: null,
  federalFTCLimit: null,
  stateMinimumTax: null,
  stateApportionmentRate: null,
  statePrePostNOL: null,
  NOL: null,
  recordVA: null,
  currentTaxRate: null,
  deferredTaxRate: null,
  comment: '',
  homeOfficeCompanyCode: null,
  filingGroup: null,
});

export const getTaxRateToUpdateMessage = taxRatesToUpdate => `A deferred rate change was detected and ${taxRatesToUpdate} rate change entries will be submitted.`;

export const getUnapprovedEntryMessage = unapprovedEntryCount => `You have ${unapprovedEntryCount} unapproved tax entries that are included in the rate change entry generation.`;
